/**
 * Baseball Ask SLAM AI - Modern AI chat interface for baseball
 *
 * Features:
 * - Claude/ChatGPT-style lightweight interface
 * - Split-panel layout with Canvas for artifacts
 * - Inline agent trace visualization
 * - AG-UI widget rendering
 * - Baseball-specific prompts and Statcast context
 * - File upload (video, CSV, JSON, PDF, images)
 * - Model selection (Gemini 2.5/3)
 * - SSE streaming for real-time responses
 *
 * Refactored: Jan 2026 - Now uses AskSLAMAI component
 */

import React from 'react';
import AskSLAMAI from '../../components/chat/AskSLAMAI';

// Baseball-specific sample prompts
const BASEBALL_PROMPTS = [
  { id: 1, text: "Analyze Corbin Burnes' pitch arsenal", icon: '⚾' },
  { id: 2, text: 'Compare spin rates of elite sliders', icon: '📊' },
  { id: 3, text: 'Scouting report on opposing starter', icon: '🔍' },
  { id: 4, text: 'Best approach vs high velocity pitchers', icon: '💨' },
  { id: 5, text: 'Analyze pitcher tendencies in 2-strike counts', icon: '🎯' },
  { id: 6, text: 'Release point analysis for pitch tipping', icon: '👀' },
];

/**
 * BaseballAskAI - Baseball-specific wrapper for AskSLAMAI
 *
 * Uses the modern Claude/ChatGPT-style interface with:
 * - Orange accent color for baseball
 * - Baseball-specific prompts
 * - Statcast endpoint for agent chat
 */
export default function BaseballAskAI() {
  return (
    <AskSLAMAI
      sport="baseball"
      prompts={BASEBALL_PROMPTS}
      endpoint="/api/chat/context/stream"
      accentColor="orange"
      enableAgentBuilder
    />
  );
}
